import React, { useEffect, useState } from "react";
import { CalendarBlank } from "@phosphor-icons/react";
import { toast } from "sonner";
import api from "../lib/api";

const DAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

function hourLabel(h) {
  const ampm = h < 12 ? "AM" : "PM";
  const hr = h % 12 === 0 ? 12 : h % 12;
  return `${hr}:00 ${ampm}`;
}

/** DigestSchedulePicker — choose which day + hour (UTC) the weekly digest arrives. */
export default function DigestSchedulePicker() {
  const [sched, setSched] = useState(null);

  useEffect(() => {
    api.get("/users/me/digest-schedule").then((r) => setSched(r.data)).catch(() => {});
  }, []);

  const save = async (day, hour) => {
    setSched((s) => ({ ...s, day, hour }));
    try {
      await api.put("/users/me/digest-schedule", { day, hour });
      toast.success(`Weekly digest set to ${DAYS[day]} at ${hourLabel(hour)} UTC`);
    } catch (e) {
      toast.error("Could not save digest schedule");
    }
  };

  if (!sched) return null;

  return (
    <div className="flex items-center justify-between p-4 rounded-2xl bg-white/5 border border-white/5" data-testid="digest-schedule">
      <div className="flex items-center gap-3 min-w-0">
        <CalendarBlank size={18} className="text-papaya" weight="duotone" />
        <div className="min-w-0">
          <span className="font-bold text-sm text-cream block">Weekly digest arrives</span>
          <span className="text-cream/40 text-[10px]">Times are UTC</span>
        </div>
      </div>
      <div className="flex items-center gap-2 flex-shrink-0">
        <select
          value={sched.day}
          onChange={(e) => save(parseInt(e.target.value, 10), sched.hour)}
          data-testid="digest-day-select"
          className="bg-white/10 text-cream text-xs rounded-full px-3 py-1.5 border border-white/10 focus:border-papaya outline-none"
        >
          {DAYS.map((d, i) => <option key={i} value={i} className="bg-ink">{d}</option>)}
        </select>
        <select
          value={sched.hour}
          onChange={(e) => save(sched.day, parseInt(e.target.value, 10))}
          data-testid="digest-hour-select"
          className="bg-white/10 text-cream text-xs rounded-full px-3 py-1.5 border border-white/10 focus:border-papaya outline-none"
        >
          {Array.from({ length: 24 }).map((_, h) => (
            <option key={h} value={h} className="bg-ink">{hourLabel(h)}</option>
          ))}
        </select>
      </div>
    </div>
  );
}
